module.exports = __webpack_public_path__ + "img/violet_090.5880bb1a.png";